import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import RegistrationFormPreview from './RegistrationFormPreview';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '1px solid #eee',
    borderRadius: '10px',
    boxShadow: 24,
    p: 2.5,
    paddingTop: 0,
    overflow: 'scroll'
};

const RegistrationInfo = ({ selectedReg = {}, showRegInfo, handleClose }) => {

    const renderModalContent = () => {
        return (
            <Fade in={showRegInfo}>
                <Box sx={style}>
                    <div className="d-flex justify-content-between pt-3 modal-head">
                        <h6>Student Information {selectedReg.is_registration_completed ? '(Registration Status: COMPLETE)' : '(Registration Status: INCOMPLETE)'}</h6>
                        <i className="fa fa-times" style={{cursor: "pointer"}} onClick={handleClose} aria-hidden="true"></i>
                    </div>
                    <RegistrationFormPreview valObj={selectedReg} isFromFaculty />
                </Box>
            </Fade>
        );
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={showRegInfo}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {renderModalContent()}
        </Modal>
    );
}

export default RegistrationInfo;